export const companyColors = {
  vcam: '#08538A',
  nhsv: '#f8c000',
  fmarket: '#0368FF',
  stag: 'blue',
};

export const companyOptions = [
  { value: 'stag', label: 'Stag' },
  { value: 'fmarket', label: 'FMarket' },
  { value: 'nhsv', label: 'NHSV' },
  { value: 'vcam', label: 'VCAM' },
];

export const identificationTypeLabels = {
  1: 'CCCD/CMND',
  2: 'Passport',
};

export const orderTypeOptions = [
  { value: 'buy', label: 'Mua' },
  { value: 'sell', label: 'Bán' },
];
